export enum UserAuthorization {
	GET_AUTHORIZATION_PROFILE_START = 'GET_AUTHORIZATION_PROFILE_START',
	GET_AUTHORIZATION_PROFILE_SUCCESS = 'GET_AUTHORIZATION_PROFILE_SUCCESS',
	GET_AUTHORIZATION_PROFILE_FAIL = 'GET_AUTHORIZATION_PROFILE_FAIL',
}
